import React from 'react'
import intl from 'react-intl-universal';
import { Image } from 'antd';
import { LeftOutlined, TagOutlined, EnvironmentOutlined, PhoneOutlined, GlobalOutlined } from '@ant-design/icons';
// import { timeFormat } from '../../../utils'
import { uniqBy } from 'lodash'
import Nav from '../../../component/nav/nav'
import Banner from '../../../component/Banner/Banner'
import FilterComponent from '../../../component/FilterComponent/FilterComponent'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import APagination from '../../../component/Pagination/Pagination'
import Foot from '../../../component/Foot/Foot'
import PopupSearch from '../../../component/PopupSearch/PopupSearch'


import column from '../../../api/column'
import merchantsInfo from '../../../api/yellow'
import { Search, Dropdown, InfiniteScroll, Loading } from 'antd-mobile'


export default class yellowPageList extends React.Component {
    constructor() {
        super()
        this.state = {
            breadArray: [
                {
                    name: intl.get('KUNSHILANYISHOU'),
                    path: '/main',
                    navData: '1'
                },
                {
                    name: intl.get('SHNGAJIA'),
                    path: '/yellowpages',
                    navData: '2'
                },
                {
                    name: intl.get('GENGDUOSHANGJAI'),
                    path: '/yellowPageList',
                    navData: '2'
                }
            ],
            listData: [],
            totalCount: 0,
            peopleLikeData: [],
            pageNum: 1,
            pageSize: 10,
            // 移动端
            mainTypeList: [],
            secondaryTypeList: [],
            mainTypeName: intl.get('ZHUFENLEI'),
            cityTypeName: intl.get('QUANBUDIQU'),
            cityTypeList: [
                {
                    id: '',
                    name: intl.get('QUANBUDIQU')
                },
                {
                    id: 1,
                    name: intl.get('BULISB')
                },
                {
                    id: 2,
                    name: intl.get('HUANGJIANHAN')
                },
                {
                    id: 3,
                    name: intl.get('YANGHUANGHANHAN')
                },
                {
                    id: 4,
                    name: intl.get('KAIENSI')
                },
            ],
            secondTypeName: intl.get('FENLEI'),
            regionName: intl.get('QUANBUDIQU'),
            hasMore: true,
            phoneListData: [],
            activeKey: '',
            popvisible: false,
            listvalue: sessionStorage['SHOPSEARCHPARMS'],
            adList: [],

        }
    }

    componentDidMount() {
        this.initList({})
        this.getPeopleLikeData()
        this.initCategory()
        this.getAds()
    }

    componentWillUnmount() {
        sessionStorage['SHOPSEARCHPARMS'] = ''
        sessionStorage.removeItem('ISHOT')
    }

    getAds = () => {
        merchantsInfo.advertisementList({}).then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    let apiData = result.data.filter(item => item.type === 9)
                    this.setState({
                        adList: apiData[0]?.path ? JSON.parse(apiData[0]?.path) : [{ firstItemUrl: '', picPath: '' }],
                    })
                }
            })
    }

    initList = (
        {
            merchantsName = sessionStorage['SHOPSEARCHPARMS'],
            sort = sessionStorage['SORT'],
            language = sessionStorage['language'],
            firstCategory = sessionStorage['MAINTYPE'] !== undefined && sessionStorage['MAINTYPE'] !== null ? sessionStorage['MAINTYPE'] : 11,
            isHot = sessionStorage['ISHOT'],
            merchantsType = sessionStorage['SECONDTYPE'],
            regionId = sessionStorage['CITY'],
            pageSize = this.state.pageSize,
            pageNum = this.state.pageNum,
        }) => {
        merchantsInfo.merchantsInfoListWeb({
            merchantsName,
            sort,
            language,
            firstCategory,
            isHot,
            merchantsType,
            regionId,
            pageSize,
            pageNum
        })
            .then(res => res.json())
            .then(result => {
                console.log('result3', result)
                if (result.ret === 200) {
                    this.setState({
                        totalCount: result.data.totalCount,
                        listData: result.data.list,
                        phoneListData: result.data.list,
                        activeKey: undefined
                    })
                }
            })
    }

    getPeopleLikeData = () => {
        merchantsInfo.merchantsInfoListWeb({
            isHot: 1,
            language: sessionStorage['language'],
            pageSize: 10,
            pageNum: 1
        })
            .then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    this.setState({
                        peopleLikeData: result.data.list
                    })
                }
            })
    }

    filterIsHot = (hot) => {
        if (hot === 1) {
            return (
                <div className="yellow_page_list_left_item_img_top">
                    <div className="hot_recommend_content_top_icon"></div>
                    <div className="yellow_page_list_left_item_img_top_text">
                        {intl.get('ZHIDING')}

                    </div>
                </div>
            )
        }
    }

    handleChangePage = (page, pageSize) => {
        console.log(page, pageSize)
        this.setState({
            pageNum: page,
            pageSize: pageSize
        }, () => {
            this.initList({})
        })
    }

    handleFilter = () => {
        this.setState({
            pageNum: 1
        }, () => {
            this.initList({ pageNum: this.state.pageNum })

        })
    }

    goToDetail = (e) => {
        sessionStorage['SHOPID'] = e
        let urlParms = JSON.stringify(e)
        this.props.history.push(`/yellowPagesDetail/${urlParms}`)
    }





    // 移动端 ====================================================================================================================================================================?================
    getShopCategoryListByApi = async ({
        parentId = 2,
        language = sessionStorage['language'],
        stat = 1
    }) => {
        const result = await column.columnInfoWeb({ parentId, language, stat })
        const apiData = await result.json()
        return apiData.data.sort((item1, item2) => {
            return item1.id - item2.id
        })
    }

    initCategory = async () => {
        let a = await this.getShopCategoryListByApi({})
        let b = await this.getShopCategoryListByApi({ parentId: sessionStorage['MAINTYPE'] ? sessionStorage['MAINTYPE'] : 11 })
        if (sessionStorage['MAINTYPE'] === undefined) {
            sessionStorage['MAINTYPE'] = 11
        }
        sessionStorage['SELLERTYPE'] = ''
        sessionStorage['DEALTYPE'] = ''
        sessionStorage['INDUSTRY'] = ''
        sessionStorage['LETOUTTYPE'] = ''
        sessionStorage['SORT'] = ''
        console.log('a', a)
        this.setState({
            mainTypeList: a ?? [],
            secondaryTypeList: b ?? [],
        }, () => {
            this.changeLang()
        })
    }

    handleChooseMainType = async (val) => {
        sessionStorage['MAINTYPE'] = val.id
        sessionStorage['SECONDTYPE'] = ''
        sessionStorage['SELLERTYPE'] = ''
        sessionStorage['DEALTYPE'] = ''
        sessionStorage['INDUSTRY'] = ''
        sessionStorage['LETOUTTYPE'] = ''
        sessionStorage['SORT'] = ''
        let b = []
        b = await this.getShopCategoryListByApi({ parentId: val.id })

        this.setState({
            secondaryTypeList: b ?? [],
            phoneListData: [],
            secondTypeName: intl.get('FENLEI'),
            regionName: intl.get('QUANBUDIQU'),
        }, () => {
            this.changeLang()
            this.handleFilter()

        })
    }

    // 语言切换
    changeLang = () => {
        const mainObj = this.state.mainTypeList.find(item => {
            return Number(sessionStorage['MAINTYPE']) === item.id
        })
        const cityObj = this.state.cityTypeList.find(item => {
            if (sessionStorage['CITY'] === '') {
                return item.id === ''
            } else {
                return Number(sessionStorage['CITY']) === item.id
            }
        })
        this.setState({
            mainTypeName: mainObj?.columnName ?? intl.get('ZHUFENLEI'),
            cityTypeName: cityObj?.name
        })

    }

    // 次级分类
    handleChooseSecondType = (val) => {
        sessionStorage['SECONDTYPE'] = val.id

        this.setState({
            secondTypeName: val.columnName
        }, () => {
            this.handleFilter()
        })
    }

    // 城市选择
    handleChooseCity = (val) => {
        sessionStorage['CITY'] = val.id
        this.setState({
            regionName: val.name
        }, () => {
            this.changeLang()
            this.handleFilter()
        })
    }





    InfiniteScrollContent = () => {
        return (
            <>
                {this.state.hasMore ? (
                    <>
                        <span>Loading</span>
                        <Loading />
                    </>
                ) : (
                    <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
                )}
            </>
        )
    }

    loadMore = async () => {

        let res = await merchantsInfo.merchantsInfoListWeb(
            {
                merchantsName: sessionStorage['SHOPSEARCHPARMS'],
                sort: sessionStorage['SORT'],
                language: sessionStorage['language'],
                firstCategory: sessionStorage['MAINTYPE'] !== undefined && sessionStorage['MAINTYPE'] !== null ? sessionStorage['MAINTYPE'] : 11,
                isHot: sessionStorage['ISHOT'],
                merchantsType: sessionStorage['SECONDTYPE'],
                regionId: sessionStorage['CITY'],
                pageSize: this.state.pageSize,
                pageNum: this.state.pageNum,
            }
        )
        let result = await res.json()
        console.log('1212', 1212)
        let arr = []
        arr = this.state.listData
        console.log('this.state.phoneListData', this.state.phoneListData)
        if (result.ret === 200 && this.state.pageSize < result.data.totalCount) {
            this.setState({
                pageSize: this.state.pageSize + 10,
                totalCount: result.data.totalCount,
                phoneListData: uniqBy([...arr, ...result.data.list], 'id'),
            });
        } else {
            this.setState({
                hasMore: false
            })
        }

    }

    handleSelect = (e) => {
        console.log('e', e)
        this.setState({
            activeKey: e
        })
    }

    gotoIndex = () => {
        this.props.history.push('/yellowpages')
    }

    handleSetVisible = (e) => {
        this.setState({
            popvisible: false,
            listvalue: e

        }, () => {
            this.initList({})
        })
    }

    handleFocus = () => {
        this.setState({
            popvisible: true,
        })
        this.$phoneSearchEvent.searchFocus()
    }

    searchEvevnt = (element) => {
        this.$phoneSearchEvent = element
    }

    render() {
        document.title = this.state.mainTypeName + '-' + this.state.secondTypeName + "-昆士兰首家中英双语黄页";
        document.querySelector('meta[property="og:title"]').setAttribute('content',  this.state.mainTypeName + '-' + this.state.secondTypeName + 'EQLD昆士兰易搜黄页');
        document.querySelector('meta[property="og:description"]').setAttribute('content', '寻昆州本地服务，找各行业信赖商家，尽在易搜黄页！');
        document.querySelector('meta[itemprop="description"]').setAttribute('content', '寻昆州本地服务，找各行业信赖商家，尽在易搜黄页！');
        document.querySelector('meta[property="og:type"]').setAttribute('content', 'website');
        document.querySelector('meta[property="og:image"]').setAttribute('content', 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="image"]').setAttribute('content', 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="name"]').setAttribute('content', 'EQLD昆士兰易搜黄页');
        return (
            <>
                <div className="main_content">
                    <Nav history={this.props.history} props={this.props} />
                    <Banner type="1" history={this.props.history} setBannerSearch={this.handleFilter} />
                    <FilterComponent type="1" filterAction={this.handleFilter} />
                    <div className="yellow_page">
                        <BreadCrumb history={this.props.history} breadData={this.state.breadArray} style={{ paddingBottom: '0' }} />
                        <div className="yellow_page_list">
                            <div className="yellow_page_list_left">

                                {
                                    this.state.listData.map((item) => {
                                        return (
                                            <div className="yellow_page_list_left_item" key={item.id} onClick={this.goToDetail.bind(this, item.id)}>
                                                <div className="yellow_page_list_left_item_img">
                                                    {
                                                        this.filterIsHot(item.isTop)
                                                    }

                                                    <Image
                                                        width='4rem'
                                                        height='3rem'
                                                        preview={false}
                                                        src={item.path ? item.path.split(",")[0] : ''}
                                                        fallback="data:image/png;base64,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"
                                                    />
                                                </div>
                                                <div className="yellow_page_list_left_item_msg">
                                                    <div className="yellow_page_list_left_item_msg_title">
                                                        {item.merchantsName}
                                                    </div>
                                                    <div className="yellow_page_list_left_item_msg_tag">
                                                        {item.tags}
                                                    </div>
                                                    <div className="yellow_page_list_left_item_msg_box">
                                                        {/* <div className="yellow_page_list_left_item_msg_box_item">
                                                        上门服务
                                                    </div>
                                                    <div className="yellow_page_list_left_item_msg_box_item">
                                                        上门服务
                                                    </div> */}
                                                    </div>
                                                    <div className="yellow_page_list_left_item_msg_bottom">
                                                        <div className="yellow_page_list_left_item_msg_bottom_phone">
                                                            {intl.get('LIANXIDIANHUA')}：{item.phone}
                                                        </div>
                                                        <div className="yellow_page_list_left_item_msg_bottom_time">
                                                            {intl.get('YINYESHIJIAN')}：{item.openTime} - {item.endTime}
                                                        </div>
                                                        <div className="yellow_page_list_left_item_msg_bottom_address">
                                                            {intl.get('DIZHI')}：{item.address}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }





                            </div>

                            <div className="yellow_page_list_right">
                                <div className="yellow_page_list_right_ads">
                                    {
                                        this.state.adList.map((item, index) => {
                                            return (
                                                <div className="yellow_page_list_right_ads_item" key={index}>
                                                    <a href={item?.firstItemUrl} target="_blank">
                                                        <Image
                                                            width='2.5rem'
                                                            height='1.7rem'
                                                            preview={false}
                                                            src={item?.picPath}
                                                        />
                                                    </a>
                                                </div>
                                            )
                                        })
                                    }
                                </div>


                                <div className="yellow_page_list_right_people_like">
                                    <div className="yellow_page_list_right_people_like_title">{intl.get('DAJIADOUZAIKAN')}</div>


                                    {
                                        this.state.peopleLikeData.map(item => {
                                            return (
                                                <div className="yellow_page_list_right_people_like_item" key={item.id} onClick={this.goToDetail.bind(this, item.id)}>
                                                    <div className="yellow_page_list_right_people_like_item_img">
                                                        <Image
                                                            width='2.18rem'
                                                            height='1.2rem'
                                                            preview={false}
                                                            src={item.path ? item.path.split(",")[0] : ''}
                                                            fallback="data:image/png;base64,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"
                                                        />
                                                    </div>
                                                    <div className="yellow_page_list_right_people_like_item_text">
                                                        <div className="yellow_page_list_right_people_like_item_text_title">
                                                            {item.merchantsName}
                                                        </div>
                                                        <div className="yellow_page_list_right_people_like_item_text_msg">
                                                            {item.tags}
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })
                                    }





                                </div>

                            </div>
                        </div>

                        <div className="yellow_page_pagine">
                            <APagination pageNum={this.state.pageNum} total={this.state.totalCount} current={this.state.pageNum} changePage={this.handleChangePage} />

                        </div>

                    </div>

                    <Foot history={this.props.history} />

                </div>

                {/* 移动端=========================================================================================================================================================================================================================================================================== */}
                <div className="phone_content bbslist">
                    <div className="bbslist_search">
                        <LeftOutlined onClick={this.gotoIndex} />
                        <div className="bbslist_search_item">
                            <Search placeholder={intl.get('KUNSHILANYISHOU')} className="phone_bbs_index_search_input_item" onFocus={this.handleFocus} value={this.state.listvalue} />
                            <PopupSearch visible={this.state.popvisible} type="1" history={this.props.history} setVisible={this.handleSetVisible} searchEvevnt={this.searchEvevnt} />

                        </div>
                    </div>
                    <div className="bbslist_filter">
                        <Dropdown onChange={this.handleSelect} activeKey={this.state.activeKey}>
                            <Dropdown.Item key='sorter' title={this.state.mainTypeName}>
                                <div style={{ padding: 12, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {
                                        this.state.mainTypeList.map((item, index) => {
                                            return (
                                                <div className="sorter_item" key={index} onClick={this.handleChooseMainType.bind(this, item)}>
                                                    {item.columnName}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item key='bizop' title={this.state.secondTypeName}>
                                <div style={{ padding: 12, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {
                                        this.state.secondaryTypeList.map((item, index) => {
                                            return (
                                                <div className="sorter_item" key={index} onClick={this.handleChooseSecondType.bind(this, item)}>
                                                    {item.columnName}
                                                </div>
                                            )
                                        })
                                    }


                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item key='more' title={this.state.regionName}>
                                <div style={{ padding: 12, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {
                                        this.state.cityTypeList.map((item, index) => {
                                            return (
                                                <div className="sorter_item" key={index} onClick={this.handleChooseCity.bind(this, item)}>
                                                    {item.name}
                                                </div>
                                            )

                                        })
                                    }
                                </div>
                            </Dropdown.Item>
                        </Dropdown>

                    </div>



                    <div className="phone_bbs_content bbs_list_content">

                        {
                            this.state.phoneListData.map((item, index) => {
                                return (
                                    <div className="shop_content" key={index} onClick={this.goToDetail.bind(this, item.id)}>
                                        <div className="shop_content_left">
                                            <Image
                                                width={'8rem'}
                                                height={'8rem'}
                                                src={item.path ? item.path.split(",")[0] : ''}
                                                fallback="data:image/png;base64,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"
                                                preview={false}
                                                style={{ borderRadius: '10px 10px 10px 10px' }}
                                            />
                                        </div>
                                        <div className="shop_content_right">
                                            <div className="shop_content_right_title"><span className="shop_content_right_title_name">{item.merchantsName}</span> </div>
                                            <div className="shop_content_right_item">
                                                <TagOutlined style={{ color: '#42d8d9' }} />
                                                <span className="shop_content_right_item_title">{item.tags}</span>
                                            </div>

                                            <div className="shop_content_right_item">
                                                <PhoneOutlined style={{ color: '#42d8d9' }} />
                                                <span className="shop_content_right_item_title">{item.phone}</span>
                                            </div>

                                            <div className="shop_content_right_item">
                                                <GlobalOutlined style={{ color: '#42d8d9' }} />
                                                <span className="shop_content_right_item_title">{item.webAddress}</span>
                                            </div>

                                            <div className="shop_content_right_item">
                                                <EnvironmentOutlined style={{ color: '#42d8d9' }} />
                                                <span className="shop_content_right_item_title">{item.address}</span>
                                            </div>
                                            <div className="shop_content_right_item">
                                                <span className="shop_content_right_title_asked">{intl.get('YIXIXUN')}</span>
                                                <span className="shop_content_right_item_title">{item.clickNum}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <InfiniteScroll loadMore={this.loadMore} hasMore={this.state.hasMore} threshold={-60}>
                            {this.InfiniteScrollContent()}
                        </InfiniteScroll>



                    </div>
                </div>
            </>
        )
    }
}